import React, { useEffect, useState } from "react";

import { Button, Collapse, Popover, Progress, Spin } from "antd";
import { Line } from "react-chartjs-2";

import "./accordion.scss";
import dayjs from "dayjs";
import { EditFilled } from "@ant-design/icons";
import Dialog from "../dialog";
import { FaInfoCircle } from "react-icons/fa";
import ProgressBar from "react-bootstrap/ProgressBar";

const { Panel } = Collapse;

const Accordion = ({
  userList,
  loader,
  toggle,
  mapObjective,
  mapkeyResults,
  pageRefresh,
  page,
  pageSize,
  mapType,
}) => {
  const [modalOpen, setModalOpen] = useState({ switch: false, type: "" });
  const [editValue, setEditValue] = useState();

  const handleEdit = (data, type) => {
    setEditValue(data);
    setModalOpen({ switch: true, type: type });
  };

  const handleClose = (modalswitch) => {
    pageRefresh && pageRefresh(page, pageSize);
    setModalOpen(modalswitch);
  };

  const options = {
    ticks: {
      precision: 0,
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        min: 0,
        max: 100,
        ticks: {
          callback: function (value, index, values) {
            return value + "%";
          },
        },
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (context.parsed.y !== null) {
              label += " " + context.parsed.y + "%";
            }
            return label;
          },
        },
      },
    },
  };

  const progressChartData = (data) => {
    return {
      labels: data?.progressChart?.labels,
      datasets: [
        {
          label: "Progress",
          data: data?.progressChart?.datas,
          borderColor: "rgb(255, 99, 132)",
          backgroundColor: "rgba(255, 99, 132, 0.5)",
        },
      ],
    };
  };

  const accordionHeader = (data) => {
    return (
      <div className="d-flex align-items-center">
        <div className="row m-0 flex-1">
          <div className="col-6 col-lg-3 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0">
            <p className="f-14 f-w-500 txt-text-1 mb-0 mb-lg-1">{data.name}</p>
            <p className="f-12 f-w-400 txt-text-2">
              {data?.keyResults.length} key results
            </p>
          </div>
          <p className="col-6 col-lg-3 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-500 txt-text-1 mb-1 d-flex align-items-center">
            {dayjs(data.startDate).format("D MMM YYYY")} <span> - </span>
            {dayjs(data.endDate).format("D MMM YYYY")}
          </p>
          <p className="col-6 col-lg-2 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-500 txt-text-1 mb-1 d-flex align-items-center">
            {data.hierarchy}
          </p>
          <p className="col-6 col-lg-2 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-500 txt-text-1 mb-1 d-flex align-items-center">
            {data.objectiveType}
          </p>
          <p className="col-6 col-lg-2 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-500 txt-text-1 mb-1 d-flex align-items-center">
            <Progress
              className="objProgress"
              percent={parseFloat(data.progress)}
            />
          </p>
        </div>
        <div className="col-lg-1 d-flex align-items-center justify-content-end">
          {data.isEditable && (
            <Button
              type="text"
              shape="circle"
              onClick={() => handleEdit(data, "header")}
              icon={<EditFilled className="f-20 txt-text-2" />}
              data-telemetry="Objective Edit"
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {loader ? (
        <div className="objectives-loader d-flex align-items-center justify-content-center w-100">
          <Spin />
        </div>
      ) : (
        <div>
          {!toggle ? (
            <div className="px-lg-4 pb-lg-4 px-0 pb-0">
              <div className="row m-0 accordion-main-header">
                <p className="col-6 col-lg-3 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-700 txt-text-1">
                  Objective
                </p>
                <p className="col-6 col-lg-2 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-700 txt-text-1">
                  Start Date - End Date
                </p>
                <p className="col-6 col-lg-2 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-700 txt-text-1">
                  Level of Hierarchy
                </p>
                <p className="col-6 col-lg-2 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-700 txt-text-1">
                  Type of Objective
                </p>
                <p className="col-6 col-lg-2 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-700 txt-text-1">
                  Progress Percentage
                </p>
                <div className="col-lg-1"></div>
              </div>
              {!loader ? (
                <Collapse accordion expandIconPosition="end">
                  {userList?.length !== 0 ? (
                    userList?.map((data, index) => {
                      return (
                        <Panel header={accordionHeader(data)} key={index}>
                          <Line
                            className="accordion-line-chart"
                            options={options}
                            data={progressChartData(data)}
                          />
                          <div className="pl-3 accordion-table">
                            {data.keyResults.map((resultValue, index) => {
                              return (
                                <div
                                  className="result-section d-flex align-ites-center"
                                  key={index}
                                >
                                  <p className="py-1 px-3 key-header f-14 f-w-600 txt-text-1">
                                    KEY RESULT {++index}
                                  </p>
                                  <div className="d-flex align-items-center w-100 row mx-0">
                                    <div className="col-xl-3 col-lg-6 pb-2 pb-sm-2 pb-lg-0">
                                      <label className="f-12 f-w-500 l-h-normal txt-text-2">
                                        Name
                                      </label>
                                      <p className="f-14 l-h-normal txt-text-1">
                                        {resultValue.name}
                                      </p>
                                    </div>
                                    <div className="d-flex align-items-center mb-2 col-xl-2 col-lg-6 pb-2 pb-sm-2 pb-lg-0">
                                      <div className="me-2">
                                        <label className="f-12 f-w-500 l-h-normal txt-text-2">
                                          Starting Value
                                        </label>
                                        <p className="f-14 l-h-normal txt-text-1">
                                          {resultValue.startingValue
                                            ? resultValue.currencySymbol +
                                              resultValue.startingValue
                                            : "--"}
                                        </p>
                                      </div>
                                      <div className="ms-2">
                                        <label className="f-12 f-w-500 l-h-normal txt-text-2">
                                          Target Value
                                        </label>
                                        <p className="f-14 l-h-normal txt-text-1">
                                          {resultValue.targetValue
                                            ? resultValue.currencySymbol +
                                              resultValue.targetValue
                                            : "--"}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-6 pb-2 pb-sm-2 pb-lg-0">
                                      <label className="f-12 f-w-500 l-h-normal txt-text-2">
                                        Progress Percentage
                                      </label>
                                      <Progress
                                        percent={parseFloat(
                                          resultValue.progressPercentage
                                        )}
                                      />
                                    </div>
                                    <div className="col-xl-1 col-lg-6 pb-2 pb-sm-2 pb-lg-0">
                                      <label className="f-12 f-w-500 l-h-normal txt-text-2">
                                        Unit
                                      </label>
                                      <p className="f-14 l-h-normal txt-text-1">
                                        {resultValue.uom
                                          ? resultValue.uom
                                          : "--"}
                                      </p>
                                    </div>
                                    <div className="col-xl-2 col-lg-5 pb-2 pb-sm-2 pb-lg-0">
                                      <label className="f-12 f-w-500 l-h-normal txt-text-2">
                                        Confidence Indicator
                                      </label>
                                      <Progress
                                        className={`${
                                          parseFloat(
                                            resultValue.confidenceIndicator
                                          ) <= 50
                                            ? "below50"
                                            : `${
                                                parseFloat(
                                                  resultValue.confidenceIndicator
                                                ) <= 80
                                                  ? "below80"
                                                  : "above80"
                                              }`
                                        }`}
                                        percent={parseFloat(
                                          resultValue.confidenceIndicator
                                        )}
                                      />
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-end ml-2">
                                    {resultValue.isEditable && (
                                      <Button
                                        type="text"
                                        onClick={() =>
                                          handleEdit(resultValue, "keyResult")
                                        }
                                        shape="circle"
                                        icon={
                                          <EditFilled className="f-16 txt-text-2" />
                                        }
                                        data-telemetry="Ker Result Edit"
                                      />
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                            {data.keyResults.length === 0 && (
                              <div className="f-14 m-4 text-center">
                                No Key Result found
                              </div>
                            )}
                          </div>
                        </Panel>
                      );
                    })
                  ) : (
                    <div className="empty-list-page">
                      <p className="f-20 f-w-bold">No data Found</p>
                    </div>
                  )}
                </Collapse>
              ) : (
                <div className="loader d-flex align-items-center justify-content-center">
                  <Spin />
                </div>
              )}
            </div>
          ) : (
            <div className="px-lg-4 pb-lg-4 px-0 pb-0">
              <p className="f-20 f-w-700 l-h-normal txt-primary">
                {mapType === "objectives"
                  ? "OKR Objectives"
                  : "OKR Key Results"}
                <Popover
                  placement="bottom"
                  content={
                    <div>
                      <label>Good going!</label>
                      <Popover
                        placement="bottom"
                        content={
                          <div>
                            <p>
                              Progress against timeline is within half the
                              permissible progress deviation parameter, or
                              better.
                            </p>
                          </div>
                        }
                      >
                        <ProgressBar variant="success" now={60} />
                      </Popover>
                      <label>Slightly behind ...</label>
                      <Popover
                        placement="bottom"
                        content={
                          <div>
                            <p>
                              Progress against timeline is delayed within half
                              the permissible progress deviation parameter.
                            </p>
                          </div>
                        }
                      >
                        <ProgressBar variant="warning" now={40} />
                      </Popover>
                      <label>Significantly behind!</label>
                      <Popover
                        placement="bottom"
                        content={
                          <div>
                            <p>
                              Progress against timeline is delayed beyond the
                              permissible progress deviation parameter.
                            </p>
                          </div>
                        }
                      >
                        <ProgressBar variant="danger" now={10} />
                      </Popover>
                    </div>
                  }
                  title={
                    <div className="d-flex align-items-center justify-content-between primary-header pt-1 pb-3">
                      <p className="f-16 f-w-600 title">Heatmap Color Info</p>
                    </div>
                  }
                  trigger="hover"
                >
                  <FaInfoCircle className="icon info" />
                </Popover>
              </p>
              <div className="d-flex flex-wrap alig-items-start row mt-4 mx-0 heat-card-container">
                {mapType === "objectives" ? (
                  <>
                    {mapObjective.data.objectives.map(
                      (objectiveData, index) => {
                        const diff =
                          objectiveData.timeElapsed -
                          mapObjective.data.settings.deviationParameter;
                        return (
                          <div
                            key={index}
                            className="col-lg-2 col-md-3 col-sm-4 col-6 p-2px"
                          >
                            <Popover
                              placement="bottom"
                              className="heatmap-popover"
                              content={
                                <div className="heatmap-popover-content">
                                  <div className="d-flex align-items-center justify-content-between primary-header pt-1 pb-3">
                                    <p className="f-16 f-w-600 title">
                                      Details
                                    </p>
                                    {objectiveData.isEditable ? (
                                      <Button
                                        type="text"
                                        color="primary"
                                        shape="circle"
                                        onClick={() =>
                                          handleEdit(objectiveData, "header")
                                        }
                                        icon={
                                          <EditFilled className="f-20 txt-primary" />
                                        }
                                        data-telemetry="Objective Edit"
                                      />
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <div className="mb-1">
                                    <p className="f-12 f-w-600 txt-text-2">
                                      Name
                                    </p>
                                    <p className="f-14 f-w-600 txt-text-1">
                                      {objectiveData.name}
                                    </p>
                                  </div>
                                  <div className="mb-1">
                                    <p className="f-12 f-w-600 txt-text-2">
                                      Progress
                                    </p>
                                    <p className="f-14 f-w-600 txt-text-1">
                                      {objectiveData.progress}%
                                    </p>
                                  </div>
                                  <div className="mb-1">
                                    <p className="f-12 f-w-600 txt-text-2">
                                      Time Elapsed
                                    </p>
                                    <p className="f-14 f-w-600 txt-text-1">
                                      {objectiveData.timeElapsed}
                                    </p>
                                  </div>
                                </div>
                              }
                            >
                              <div
                                className={`heat-card h-100 ${
                                  objectiveData.progress >=
                                  objectiveData.timeElapsed
                                    ? "best"
                                    : objectiveData.progress <
                                        objectiveData.timeElapsed &&
                                      objectiveData.progress >= diff
                                    ? "better"
                                    : objectiveData.progress <
                                        objectiveData.timeElapsed &&
                                      objectiveData.progress < diff
                                    ? "good"
                                    : ""
                                }`}
                              >
                                <p className="f-16 f-w-700 l-h-normal text-center text-text-2">
                                  {objectiveData.name}
                                </p>
                              </div>
                            </Popover>
                          </div>
                        );
                      }
                    )}
                  </>
                ) : (
                  <>
                    {mapkeyResults.data.keyResults.map(
                      (keyResultsData, index) => {
                        const diff =
                          keyResultsData.timeElapsed -
                          mapObjective.data.settings.deviationParameter;
                        return (
                          <div
                            key={index}
                            className="col-lg-2 col-md-3 col-sm-4 col-6 p-2px"
                          >
                            <Popover
                              placement="bottom"
                              className="heatmap-popover"
                              content={
                                <div className="heatmap-popover-content">
                                  <div className="d-flex align-items-center justify-content-between primary-header pt-1 pb-3">
                                    <p className="f-16 f-w-600 title">
                                      Details
                                    </p>
                                    {keyResultsData.isEditable ? (
                                      <Button
                                        type="text"
                                        color="primary"
                                        shape="circle"
                                        onClick={() =>
                                          handleEdit(
                                            keyResultsData,
                                            "keyResult"
                                          )
                                        }
                                        icon={
                                          <EditFilled className="f-20 txt-primary" />
                                        }
                                        data-telemetry="Key Result Edit"
                                      />
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <div className="mb-1">
                                    <p className="f-12 f-w-600 txt-text-2">
                                      Name
                                    </p>
                                    <p className="f-14 f-w-600 txt-text-1">
                                      {keyResultsData.name}
                                    </p>
                                  </div>
                                  <div className="mb-1">
                                    <p className="f-12 f-w-600 txt-text-2">
                                      Progress
                                    </p>
                                    <p className="f-14 f-w-600 txt-text-1">
                                      {keyResultsData.progressPercentage}%
                                    </p>
                                  </div>
                                  <div className="mb-1">
                                    <p className="f-12 f-w-600 txt-text-2">
                                      Time Elapsed
                                    </p>
                                    <p className="f-14 f-w-600 txt-text-1">
                                      {keyResultsData.timeElapsed}
                                    </p>
                                  </div>
                                </div>
                              }
                            >
                              <div
                                className={`heat-card h-100 ${
                                  keyResultsData.progressPercentage >=
                                  keyResultsData.timeElapsed
                                    ? "best"
                                    : keyResultsData.progressPercentage <
                                        keyResultsData.timeElapsed &&
                                      keyResultsData.progressPercentage >= diff
                                    ? "better"
                                    : keyResultsData.progressPercentage <
                                        keyResultsData.timeElapsed &&
                                      keyResultsData.progressPercentage < diff
                                    ? "good"
                                    : ""
                                }`}
                              >
                                <p className="f-16 f-w-700 l-h-normal text-center text-text-2">
                                  {keyResultsData.name}
                                </p>
                              </div>
                            </Popover>
                          </div>
                        );
                      }
                    )}
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      <Dialog
        resultValue={editValue}
        open={modalOpen}
        handleClose={handleClose}
      />
    </>
  );
};

export default Accordion;
